import * as React from "react";
import type { Stop } from "../types";
import { resolveStopId } from "../utils/resolveStopId";

type Args = {
  stopIds: string[];
  byId: Map<any, Stop>;
  allStops: Stop[];
};

type Result = {
  primaryStopRaw: string | null;
  resolvedStopId: string | null;
  stopMissing: boolean;
};

export function useStopDeeplink({ stopIds, byId, allStops }: Args): Result {
  const primaryStopRaw = stopIds.length === 1 ? stopIds[0] : null;
  const stopsReady = byId.size > 0 || allStops.length > 0;

  const resolvedStopId = React.useMemo(() => {
    if (!primaryStopRaw) return null;
    if (!stopsReady) return null;

    return resolveStopId(primaryStopRaw, byId, allStops);
  }, [primaryStopRaw, stopsReady, byId, allStops]);

  const stopMissing = Boolean(primaryStopRaw && stopsReady && !resolvedStopId);

  return {
    primaryStopRaw,
    resolvedStopId,
    stopMissing,
  };
}
